function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "fi:log-in"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M6.6665 11.3332L9.99984 7.99984L6.6665 4.6665",
  stroke: "#F2F2F2",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M10 8H2",
  stroke: "#F2F2F2",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M10 2H12.6667C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H10",
  stroke: "#F2F2F2",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

function SvgIconLogIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogIn);
export default __webpack_public_path__ + "static/media/icon-log-in.91435119ed5fe8c9fa5030032daeadfc.svg";
export { ForwardRef as ReactComponent };